import { HTMLCustomElement, dateUtils } from '@emartech/ui-framework-utils';
import CustomEvent from 'custom-event';
import JSLogger from '../../../utils/jslogger';
const log = new JSLogger('decommission');

class EDaterangepickerPreset extends HTMLCustomElement {
  init() {
    this._data = {};
    this._data.name = '';
    this._data.start = '';
    this._data.end = '';
    this._data.order = undefined;
    this._uuid = this._uuid();
  }

  connectedCallback() {
    this._dispatchEventOnValidData();
    log.log('EDaterangepickerPreset');
  }

  disconnectedCallback() {
    this.dispatchEvent(new CustomEvent('datarangepreset.delete', {
      bubbles: true,
      detail: {
        uuid: this._uuid
      }
    }));
  }

  static get observedAttributes() {
    return ['name', 'start', 'end', 'last', 'order'];
  }

  set name(value) {
    if (this._data.name === value) {
      return;
    }

    this._data.name = value;
    this._dispatchEventOnValidData();
  }

  set order(value) {
    if (this._data.order === value) {
      return;
    }

    this._data.order = value;
    this._dispatchEventOnValidData();
  }

  set start(value) {
    if (!dateUtils.isValid(value) || this._data.start === value) {
      return;
    }

    this._data.start = value;
    this._dispatchEventOnValidData();
  }

  set end(value) {
    if (!dateUtils.isValid(value) || this._data.end === value) {
      return;
    }

    this._data.end = value;
    this._dispatchEventOnValidData();
  }

  set last(value) {
    this._calculateStartEnd(value);
  }

  _dispatchEventOnValidData() {
    if (!this._dataIsValid()) {
      return;
    }

    this.dispatchEvent(new CustomEvent('datarangepreset.update', {
      bubbles: true,
      detail: {
        data: this._data,
        uuid: this._uuid
      }
    }));
  }

  _uuid(placeholder) {
    if (placeholder) {
      return (placeholder ^ Math.random() * 16 >> placeholder / 4).toString(16);
    } else {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, this._uuid);
    }
  }

  _dataIsValid() {
    return this._data.name !== '' && this._data.start !== '' && this._data.end !== '';
  }

  _calculateStartEnd(last) {
    const parsedLast = last.split(' ');
    const lastOf = parsedLast[parsedLast.length - 1];
    const value = parsedLast.length === 1 ? 1 : parseInt(parsedLast[0], 10);
    const handleValue = {
      'month': 'Month',
      'months': 'Month',
      'day': 'Day',
      'days': 'Day',
      'hour': 'Hour',
      'hours': 'Hour'
    };

    if (!handleValue.hasOwnProperty(lastOf)) {
      return;
    }

    this['_setLastOf' + handleValue[lastOf]](value);
  }

  _setLastOfMonth(value) {
    const calculatedStartMonth = dateUtils.subMonths(new Date(), 1);
    const calculatedEndMonth = dateUtils.subMonths(new Date(), value);

    this.start = dateUtils.format(dateUtils.startOfMonth(calculatedEndMonth), dateUtils.formats.fullDate);
    this.end = dateUtils.format(dateUtils.endOfMonth(calculatedStartMonth), dateUtils.formats.fullDate);
  }

  _setLastOfDay(value) {
    this.start = dateUtils.format(dateUtils.subDays(new Date(), value - 1), dateUtils.formats.fullDate);
    this.end = dateUtils.format(new Date(), dateUtils.formats.fullDate);
  }

  _setLastOfHour(value) {
    this.start = dateUtils.format(dateUtils.subHours(new Date(), value), dateUtils.formats.fullDateWithHoursAndMins);
    this.end = dateUtils.format(new Date(), dateUtils.formats.fullDateWithHoursAndMins);
  }
}

export default EDaterangepickerPreset;
